import React from 'react';
import { Warehouse, Ship, MapPin, Package, Truck, CheckCircle, Calendar, Check } from 'lucide-react';

const STEPS = [
  { key: 'at_warehouse',    label: 'Warehouse',  Icon: Warehouse,   desc: 'Received at origin warehouse' },
  { key: 'in_transit',      label: 'In Transit', Icon: Ship,        desc: 'Heading to Ghana' },
  { key: 'arrived_ghana',   label: 'In Ghana',   Icon: MapPin,      desc: 'Arrived in Ghana' },
  { key: 'ready_for_pickup',label: 'Pickup',     Icon: Package,     desc: 'Ready for customer pickup' },
  { key: 'out_for_delivery',label: 'Delivery',   Icon: Truck,       desc: 'Out for final delivery' },
  { key: 'delivered',       label: 'Delivered',  Icon: CheckCircle, desc: 'Delivered to you' },
];

const STATUS_COPY = {
  at_warehouse:     { title: 'At the Warehouse',   sub: 'Your package is waiting to be shipped.', color: '#1d4ed8', bg: '#dbeafe' },
  in_transit:       { title: 'On the Way!',         sub: 'Your package is heading to Ghana.',      color: '#7c3aed', bg: '#ede9fe' },
  arrived_ghana:    { title: 'Arrived in Ghana',    sub: 'Your package has landed in Ghana.',      color: '#065f46', bg: '#d1fae5' },
  ready_for_pickup: { title: 'Ready for Pickup',    sub: 'Your package is ready to be picked up.', color: '#0f766e', bg: '#ccfbf1' },
  out_for_delivery: { title: 'Out for Delivery',    sub: 'Almost there! Your package is nearby.',  color: '#b45309', bg: '#fef3c7' },
  delivered:        { title: 'Delivered!',            sub: 'Your package has been delivered.',       color: '#166534', bg: '#dcfce7' },
};

function fmt(dateStr) {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-GH', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch { return dateStr; }
}

export default function TrackCard({ item }) {
  const stepIdx = STEPS.findIndex((s) => s.key === item.status);
  const statusInfo = STATUS_COPY[item.status] || STATUS_COPY.at_warehouse;
  const progressPct = stepIdx >= 0 ? (stepIdx / (STEPS.length - 1)) * 100 : 0;

  return (
    <div className="tk-card">
      {/* Item info */}
      <div className="tk-item-header">
        <div>
          <p className="tk-item-name">{item.goods_name || 'Shipment item'}</p>
          <p className="tk-item-ref">#{item.tracking_number || item.shipping_mark}</p>
        </div>
        {item.shipping_mark && item.tracking_number && (
          <div className="tk-mark-pill">{item.shipping_mark}</div>
        )}
      </div>

      {/* Current status banner */}
      <div className="tk-status-banner" style={{ background: statusInfo.bg, color: statusInfo.color }}>
        {(() => { const SI = STEPS[stepIdx]?.Icon || Warehouse; return <SI size={22} strokeWidth={1.8} className="tk-status-icon" />; })()}
        <div>
          <p className="tk-status-title">{statusInfo.title}</p>
          <p className="tk-status-sub">{statusInfo.sub}</p>
        </div>
      </div>

      {/* ETA */}
      {item.eta_ghana && (
        <div className="tk-eta">
          <Calendar size={16} strokeWidth={1.8} />
          <div>
            <span className="tk-eta-label">Estimated arrival</span>
            <span className="tk-eta-date">{fmt(item.eta_ghana)}</span>
          </div>
        </div>
      )}

      {/* Progress track */}
      <div className="tk-progress-wrap">
        <div className="tk-progress-track">
          <div className="tk-progress-fill" style={{ width: `${progressPct}%` }} />
          {STEPS.map((step, si) => {
            const done   = si < stepIdx;
            const active = si === stepIdx;
            const DotIcon = step.Icon;
            return (
              <div
                key={step.key}
                className={`tk-dot-wrap${done ? ' done' : active ? ' active' : ''}`}
                style={{ left: `${(si / (STEPS.length - 1)) * 100}%` }}
              >
                <div className={`tk-dot${done ? ' done' : active ? ' active' : ''}`}>
                  {done ? <Check size={10} strokeWidth={3} /> : <DotIcon size={12} strokeWidth={2} />}
                </div>
                <span className="tk-dot-label">{step.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Details row */}
      {(item.weight_kg || item.quantity) && (
        <div className="tk-details-row">
          {item.quantity   && <span className="tk-detail"><strong>{item.quantity}</strong> pcs</span>}
          {item.weight_kg  && <span className="tk-detail"><strong>{item.weight_kg} kg</strong></span>}
          {item.volume_cbm && parseFloat(item.volume_cbm) > 0 && (
            <span className="tk-detail"><strong>{item.volume_cbm} CBM</strong></span>
          )}
          {item.final_fee  && parseFloat(item.final_fee) > 0 && (
            <span className="tk-detail">Fee: <strong>GHS {parseFloat(item.final_fee).toFixed(2)}</strong></span>
          )}
        </div>
      )}
    </div>
  );
}
